import React from 'react'
import { RouteObject } from 'react-router-dom'

import FormWrapper from '@sputnik/components/FormWrapper/FormWrapper'
import ApplicationProcessed from '@sputnik/pages/ApplicationProcessed'
import ApplicationSubmitted from '@sputnik/pages/ApplicationSubmitted'
import Dashboard from '@sputnik/pages/Dashboard'
import AcceptingOfferPollingPage from '@sputnik/pages/PostApplicationPages/AcceptingOfferPollingPage'
import SubmittingApplicationPollingPage from '@sputnik/pages/PostApplicationPages/SubmittingApplicationPollingPage'
import SubmissionErrorPage from '@sputnik/pages/ReviewAndSign/SubmissionErrorPage'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'

export const createLegacyDashboardRoutes = (): RouteObject[] => {
  return [
    {
      path: '/',
      element: <Dashboard />,
    },
    {
      path: PATHNAME_CONSTS.DASHBOARD_PATH,
      element: <Dashboard />,
    },
  ]
}

export const createLegacyApplicationRoutes = (): RouteObject[] => {
  return [
    {
      path: '/app/:appId/section',
      children: [
        {
          path: 'success',
          element: <ApplicationSubmitted />,
        },
        {
          path: PATHNAME_CONSTS.SUBMITTING_APPLICATION,
          element: <SubmittingApplicationPollingPage />,
        },
        {
          path: PATHNAME_CONSTS.ACCEPTING_OFFER,
          element: <AcceptingOfferPollingPage />,
        },
        {
          path: PATHNAME_CONSTS.SUBMISSION_ERROR_PATH,
          element: <SubmissionErrorPage />,
        },
        {
          path: 'processed/*',
          element: <ApplicationProcessed />,
        },
        {
          path: '*',
          element: <FormWrapper />,
        },
      ],
    },
    {
      path: '/app/success',
      element: <ApplicationSubmitted />,
    },
  ]
}
